export const ExpiredDaysPassed = (dtNotify: any) => {
  if (dtNotify != null && dtNotify != "0000-00-00 00:00:00") {
    const dtNotifyDate = new Date(dtNotify);
    const now = new Date();
    const diff = now.getTime() - dtNotifyDate.getTime();
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    return days;
  }
  return "";
};
